(function() {
  const countdownTimers = new WeakMap();

  function initCountDownForElement(countdown) {
    if (!countdown || countdownTimers.has(countdown)) return;

    // Always countdown to midnight instead of using the attribute
    const day = window.countdown && window.countdown.day ? window.countdown.day : 'd';

    function updateCountdown() {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      const countDownDate = midnight.getTime();
      
      const currentTime = Date.now();
      const distance = countDownDate - currentTime;

      if (distance < 0) {
        // Reset for next midnight instead of removing
        updateCountdown();
        return;
      }

      const d = Math.floor(distance / (1000 * 60 * 60 * 24));
      const h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const s = Math.floor((distance % (1000 * 60)) / 1000);

      if (countdown.classList.contains('product-countdown')) {
        const bar = countdown.querySelector('.product-countdown-bar');
        if (bar) {
          bar.innerHTML = `
            <span class="product-countdown-num"><span>${d}</span></span>
            <span class="divider">:</span>
            <span class="product-countdown-num"><span>${h}</span></span>
            <span class="divider">:</span>
            <span class="product-countdown-num"><span>${m}</span></span>
            <span class="divider">:</span>
            <span class="product-countdown-num"><span>${s}</span></span>
          `;
        }
      } else {
        countdown.innerHTML = `
          <span class="num">${d}<span>${day}</span></span>
          <span class="num">${h}<span class="icon">:</span></span>
          <span class="num">${m}<span class="icon">:</span></span>
          <span class="num">${s}<span class="icon">:</span></span>
        `;
      }
    }

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);
    countdownTimers.set(countdown, timer);
  }

  function initCountdowns() {
    const countdowns = document.querySelectorAll('[data-countdown]');
    countdowns.forEach(initCountDownForElement);
  }

  function cleanupCountdown(countdown) {
    const timer = countdownTimers.get(countdown);
    if (timer) {
      clearInterval(timer);
      countdownTimers.delete(countdown);
    }
  }

  if (Shopify && Shopify.designMode) {
    function onSectionReorder(e) {
      if (!e.target.querySelectorAll) return;
      
      const countdowns = e.target.querySelectorAll('[data-countdown]');
      countdowns.forEach(countdown => {
        cleanupCountdown(countdown);
        initCountDownForElement(countdown);
      });
    }

    document.addEventListener('shopify:section:load', onSectionReorder);
    document.addEventListener('shopify:section:unload', onSectionReorder);
  }

  function observeCountdowns() {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            if (node.matches && node.matches('[data-countdown]')) {
              initCountDownForElement(node);
            } else if (node.querySelectorAll) {
              const countdowns = node.querySelectorAll('[data-countdown]');
              countdowns.forEach(initCountDownForElement);
            }
          }
        });

        mutation.removedNodes.forEach(node => {
          if (node.nodeType === 1 && node.matches && node.matches('[data-countdown]')) {
            cleanupCountdown(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initCountdowns();
    observeCountdowns();
  });
})();